import { AlignItems, NotesIcon, StrongText, StyledFlex, StyledMargin } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { calendarTranslationKeys } from '../../../../../../translations';
import { AppointmentDetailsInfoItem } from '../AppointmentDetailsInfoItem';

import { AppointmentNoteModifierLink } from './AppointmentNoteModifierLink';
import { StyledText } from './AppointmentNoteInfoItem.styled';

type AppointmentNoteInfoItemProps = {
   appointmentId: number;
   note: string | undefined;
   onAppointmentNoteUpdated: VoidFunction;
};

export const AppointmentNoteInfoItem = (props: AppointmentNoteInfoItemProps): JSX.Element => {
   return props.note ? (
      <AppointmentDetailsInfoItem
         testId={'appointmentNote'}
         icon={<NotesIcon />}
         iconAlign={AlignItems.START}
         content={
            <StrongText testId={'header'}>
               <StyledMargin top={2}>
                  <Translate>
                     {calendarTranslationKeys.appointmentContextDialog.tabs.appointmentDetailsTab.noteHeader}
                  </Translate>
               </StyledMargin>
            </StrongText>
         }
         description={
            <StyledFlex gap={5} direction='column'>
               <StyledText testId='noteContent'>{props.note}</StyledText>
               <AppointmentNoteModifierLink
                  appointmentId={props.appointmentId}
                  appointmentNote={props.note}
                  onAppointmentNoteUpdated={props.onAppointmentNoteUpdated}
               />
            </StyledFlex>
         }
      />
   ) : (
      <AppointmentNoteModifierLink
         appointmentId={props.appointmentId}
         appointmentNote={props.note}
         onAppointmentNoteUpdated={props.onAppointmentNoteUpdated}
      />
   );
};
